<template>
  <app-data-editor
    :id="id"
    title="Редактирование типа упаковки"
    resource="package-types"
    :elements="elements"
    add-message="Тип упаковки добавлен"
    edit-message="Тип упаковки изменен"
    :without-remove="isAdmin ? false : true"
  />
</template>

<script>
import mixin from "../../mixins/confirm-cancel-changes.js";
import { userRoles } from "../../enums/user-roles.js";
import auth from "../../auth.js";

export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [],
    };
  },
  computed: {
    isAdmin() {
      const user = auth.getUser();
      if (user.roles.find(r => r.id === userRoles.Admin)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    isAdmin: {
      handler(value) {
        this.setElements(value);
      },
      immediate: true,
    },
  },
  methods: {
    setElements(isAdmin) {
      this.elements = [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [v => !!v || "Наименование обязательно к заполнению"],
            },
            default: "",
            disabled: !isAdmin,
          },
          {
            title: "Сокращение",
            name: "shortTitle",
            control: {
              type: "title-text",
              required: true,
              rules: [v => !!v || "Сокращение обязательно к заполнению"],
            },
            default: "",
            disabled: !isAdmin,
          },
        ],
        [
          {
            title: "Длина, м",
            name: "length",
            control: {
              type: "number",
            },
            default: 0,
            disabled: !isAdmin,
          },
          {
            title: "Ширина, м",
            name: "width",
            control: {
              type: "number",
            },
            default: 0,
            disabled: !isAdmin,
          },
        ],
      ];
    },
  },
};
</script>
